import * as React from "react";

interface IDialogDTextProps {
  isShowDialogText: boolean;
}

class DialogDText extends React.Component<IDialogDTextProps> {
  constructor(props: IDialogDTextProps) {
    super(props);
  }

  public render() {
    return (
      <svg
        className={`dialogD-text ${this.props.isShowDialogText ? "show" : ""}`}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 152.217 105.309"
      >
        <g>
          <path
            fill="#2D4670"
            d="M37.184,31h6.221v1.421H31.881v3.646c-0.012,4.024-0.908,6.935-2.691,8.73
			c-0.357-0.424-0.721-0.773-1.088-1.053c-0.021-0.012-0.039-0.023-0.051-0.033c1.082-1.115,1.779-2.616,2.092-4.5
			c-0.201,0.122-0.893,0.524-2.074,1.204l-0.52-1.472c0.279-0.111,1.211-0.557,2.793-1.338c0.023-0.735,0.035-1.254,0.035-1.556V31
			h5.15v-1.94h1.656V31z M30.26,35.482l-1.256,0.668c-0.156-0.901-0.545-1.934-1.17-3.093c-0.021-0.056-0.045-0.101-0.066-0.134
			l1.17-0.569c0.625,1.037,1.055,2.041,1.287,3.012C30.237,35.409,30.249,35.449,30.26,35.482z M38.672,39.429v3.512h4.732v1.404
			H31.631v-1.404h1.889v-5.621h1.473v5.621h2.156v-7.593h-4.297v-1.371H42.87v1.371h-4.197v2.71h3.945v1.371H38.672z"
          />
          <path
            fill="#2D4670"
            d="M60.479,35.566h-3.996c0.412,3.779,1.816,6.395,4.215,7.842c-0.424,0.279-0.814,0.703-1.172,1.271
			c-1.873-1.193-3.172-3.15-3.896-5.871c-0.68,2.51-2.08,4.511-4.197,6.003c-0.201-0.346-0.508-0.717-0.92-1.119v1.07h-1.488v-5.853
			h-1.506v0.418c-0.012,2.241-0.541,3.929-1.588,5.066c-0.324-0.254-0.725-0.506-1.205-0.75c0.904-0.982,1.355-2.427,1.355-4.333
			v-0.401h-1.205v-1.439h4.148v-2.156H46.18v-0.017h-0.652v-5.486h1.439v4.064h2.057v-4.801h1.488v14.418
			c2.186-1.595,3.49-3.803,3.914-6.624c0.055-0.413,0.1-0.848,0.133-1.305h-3.479v-1.572h3.529v-0.117v-4.801h1.521v4.816v0.102
			h4.348V35.566z M60.196,32.573l-1.338,0.686c-0.414-0.893-1.043-1.856-1.891-2.894c-0.057-0.078-0.111-0.145-0.168-0.2
			l1.271-0.603c0.881,0.981,1.566,1.934,2.057,2.858C60.151,32.478,60.172,32.528,60.196,32.573z"
          />
          <path
            fill="#2D4670"
            d="M63.774,36.92c-0.525,0-0.908-0.234-1.154-0.703c-0.111-0.211-0.168-0.435-0.168-0.668
			c0-0.568,0.234-0.982,0.703-1.237c0.189-0.112,0.396-0.168,0.619-0.168c0.523,0,0.902,0.234,1.137,0.702
			c0.111,0.224,0.168,0.458,0.168,0.703c0,0.567-0.229,0.976-0.686,1.221C64.192,36.871,63.985,36.92,63.774,36.92z M63.774,43.645
			c-0.535,0-0.92-0.229-1.154-0.688c-0.111-0.211-0.168-0.439-0.168-0.686c0-0.567,0.234-0.979,0.703-1.237
			c0.189-0.11,0.396-0.167,0.619-0.167c0.523,0,0.902,0.235,1.137,0.703c0.111,0.224,0.168,0.457,0.168,0.701
			c0,0.581-0.24,0.995-0.719,1.239C64.18,43.6,63.985,43.645,63.774,43.645z"
          />
          <path
            fill="#2D4670"
            d="M36.381,63.258h6.789v1.537H27.952v-1.537h6.789v-3.947h-4.883v-1.521h4.883v-3.412h-3.795
			c-0.568,1.082-1.139,1.963-1.707,2.643c-0.445-0.367-0.93-0.686-1.455-0.953c1.271-1.338,2.275-3.305,3.012-5.904
			c0.033-0.1,0.061-0.199,0.082-0.301l1.656,0.385c-0.211,0.715-0.508,1.566-0.887,2.559h3.094v-3.178h1.641v3.178h5.969v1.572
			h-5.969v3.412h5.334v1.521h-5.334V63.258z"
          />
          <path
            fill="#2D4670"
            d="M46.682,55.363h10.971c0.045,5.564,0.529,8.352,1.455,8.361c0.246-0.021,0.385-0.83,0.418-2.424
			c0.324,0.436,0.67,0.764,1.037,0.986c-0.078,1.438-0.301,2.336-0.668,2.693c-0.234,0.211-0.535,0.318-0.904,0.318
			c-1.148,0-1.939-0.967-2.375-2.895c-0.289-1.248-0.469-3.178-0.535-5.785h-9.465v-1.188c-0.18,0.178-0.313,0.305-0.402,0.385
			c-0.479-0.412-0.98-0.758-1.504-1.037c1.393-1.037,2.502-2.438,3.328-4.199c0.154-0.334,0.295-0.664,0.418-0.986l1.688,0.402
			c-0.178,0.469-0.34,0.842-0.484,1.121H59.86v1.254H48.991C48.309,53.496,47.54,54.494,46.682,55.363z M53.555,57.104l1.406,0.451
			c-0.691,0.959-1.277,1.689-1.758,2.191h2.459v1.236h-4.248v0.066L51.481,61c1.83,1.004,3.189,1.883,4.082,2.641l-1.037,0.971
			c-0.703-0.635-1.74-1.375-3.111-2.225v2.912h-1.488v-3.463c-1.082,1.316-2.342,2.359-3.779,3.127
			c-0.045,0.023-0.084,0.045-0.117,0.066c-0.256-0.4-0.596-0.791-1.02-1.17c1.348-0.568,2.553-1.393,3.611-2.475
			c0.135-0.133,0.258-0.268,0.369-0.402h-3.479v-1.236h2.24c-0.189-0.658-0.586-1.355-1.188-2.092l1.221-0.484
			c0.646,0.77,1.064,1.455,1.254,2.057l-1.188,0.52h2.074v-2.793h1.488v2.793h1.74l-0.986-0.418
			C52.704,58.637,53.165,57.895,53.555,57.104z M58.506,54.443H48.438v-1.186h10.068V54.443z"
          />
          <path
            fill="#2D4670"
            d="M68.59,55.113c1.193,0.947,2.369,2.09,3.529,3.428c0.1,0.123,0.193,0.234,0.283,0.336l-1.455,1.252
			c-1.182-1.438-2.436-2.709-3.762-3.813L68.59,55.113z"
          />
          <path
            fill="#2D4670"
            d="M84.729,61.385l0.25,1.303c-2.363,0.838-4.26,1.5-5.686,1.992l-0.318-1.422l0.502-0.15v-6.004
			h1.205v5.637l0.969-0.32v-6.889h-2.074v-5.219h5.035v5.219h-1.689v2.408h1.672v1.338h-1.672v2.709
			C82.956,61.975,83.557,61.775,84.729,61.385z M80.797,51.617v2.609h2.525v-2.609H80.797z M94.479,60.666h-3.244
			c0.779,1.08,1.816,1.955,3.109,2.625c0.168,0.088,0.336,0.166,0.502,0.234c-0.367,0.301-0.707,0.703-1.02,1.203
			c-1.215-0.635-2.32-1.627-3.313-2.977c-0.055-0.066-0.105-0.133-0.15-0.199v3.762h-1.438v-3.563
			c-0.992,1.359-2.129,2.375-3.412,3.043c-0.234-0.391-0.563-0.785-0.986-1.188c1.227-0.512,2.291-1.299,3.193-2.355
			c0.168-0.203,0.318-0.398,0.453-0.586h-3.328v-1.305h4.08v-1.154h-3.797v-3.83h4.182v3.697h0.586v-3.697h4.314v3.83h-3.83v1.154
			h4.098V60.666z M88.057,57.053v-1.537h-1.74v1.537H88.057z M92.622,50.078v3.629h-5.986v-3.629H92.622z M91.118,52.57v-1.354
			h-3.061v1.354H91.118z M91.118,55.516v1.537h1.84v-1.537H91.118z"
          />
          <path
            fill="#2D4670"
            d="M99.145,53.674v3.145c-0.012,3.814-0.564,6.639-1.656,8.48c-0.424-0.346-0.854-0.607-1.287-0.787
			c-0.035-0.01-0.057-0.016-0.068-0.016c0.938-1.539,1.422-3.932,1.455-7.176c0-0.166,0-0.34,0-0.518v-4.299h5.469v-2.893h1.59
			v1.004h5.619v1.086h-5.619v0.803h5.418l0.268-0.066l1.154,0.301c-0.334,0.98-0.664,1.75-0.986,2.307
			c0.412,0.125,0.713,0.197,0.902,0.219c-0.078,0.646-0.307,1.053-0.686,1.221c-0.268,0.111-0.67,0.168-1.205,0.168H105.6
			c-1.182,0-1.924-0.141-2.225-0.42c-0.213-0.211-0.318-0.541-0.318-0.986l-3.109,0.135l-0.035-0.836l3.145-0.117v-0.754H99.145z
			 M99.145,64.996l-1.037-0.869c0.947-0.424,1.561-1.154,1.84-2.189l1.221,0.4C100.833,63.598,100.159,64.482,99.145,64.996z
			 M109.915,57.254v3.912h-5.084c0.658,0.369,1.154,0.754,1.488,1.154l-0.953,0.838c-0.424-0.525-1.076-1.01-1.957-1.455
			c-0.057-0.033-0.105-0.063-0.15-0.084l0.518-0.453h-3.527v-3.912H109.915z M101.704,58.074v0.717h2.574v-0.717H101.704z
			 M101.704,59.596v0.736h2.574v-0.736H101.704z M104.01,63.877h2.393c0.313,0,0.506-0.09,0.584-0.27
			c0.057-0.154,0.096-0.428,0.117-0.818c0.336,0.213,0.764,0.373,1.289,0.486c-0.102,0.857-0.34,1.398-0.719,1.621
			c-0.246,0.133-0.609,0.199-1.088,0.199h-2.727c-1.004,0-1.633-0.172-1.889-0.518c-0.168-0.246-0.252-0.625-0.252-1.137v-1.605
			h1.455v1.588c0,0.234,0.072,0.369,0.217,0.402C103.514,63.859,103.721,63.877,104.01,63.877z M105.7,55.748h3.629
			c0.424,0,0.686-0.082,0.787-0.252c0.043-0.098,0.078-0.217,0.1-0.35l-1.154-0.385c0.189-0.367,0.346-0.73,0.469-1.088h-4.984
			v0.688l4.031-0.168l0.033,0.803l-4.064,0.184v0.066c0,0.246,0.102,0.396,0.301,0.453C105.002,55.732,105.288,55.748,105.7,55.748z
			 M108.409,58.791v-0.717h-2.691v0.717H108.409z M108.409,60.332v-0.736h-2.691v0.736H108.409z M108.159,62.287l1.188-0.584
			c0.98,0.758,1.756,1.533,2.324,2.324c0.057,0.09,0.105,0.168,0.15,0.234l-1.287,0.684c-0.402-0.734-1.082-1.525-2.041-2.375
			C108.37,62.471,108.258,62.377,108.159,62.287z"
          />
          <path
            fill="#2D4670"
            d="M118.528,57.486c0-0.857,0.34-1.553,1.02-2.088c0.49-0.391,1.043-0.586,1.656-0.586
			c0.879,0,1.588,0.346,2.123,1.037c0.367,0.49,0.553,1.037,0.553,1.637c0,0.871-0.346,1.572-1.037,2.109
			c-0.48,0.379-1.027,0.566-1.639,0.566c-0.859,0-1.557-0.338-2.092-1.018C118.721,58.664,118.528,58.111,118.528,57.486z
			 M119.563,57.486c0,0.592,0.258,1.055,0.77,1.391c0.279,0.166,0.568,0.25,0.871,0.25c0.602,0,1.064-0.256,1.387-0.77
			c0.168-0.268,0.252-0.559,0.252-0.871c0-0.6-0.258-1.063-0.77-1.387c-0.268-0.166-0.559-0.25-0.869-0.25
			c-0.58,0-1.037,0.244-1.373,0.736C119.653,56.863,119.563,57.164,119.563,57.486z"
          />
        </g>
      </svg>
    );
  }
}

export default DialogDText;



// WEBPACK FOOTER //
// ./src/fearCity/components/DialogDText.tsx